import { render, staticRenderFns } from "./PdfEditorView.vue?vue&type=template&id=61d468e4&scoped=true&"
import script from "./PdfEditorView.vue?vue&type=script&lang=js&"
export * from "./PdfEditorView.vue?vue&type=script&lang=js&"
import style0 from "./PdfEditorView.vue?vue&type=style&index=0&id=61d468e4&scoped=true&lang=css&"
import style1 from "./PdfEditorView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d468e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VIcon,VList,VListItem,VListItemIcon,VListItemTitle,VMenu,VSpacer,VToolbar,VToolbarTitle,VTooltip})
